import { VALIDATION as CONNETTORI_VALIDATION } from "../feature/services/connettori";
import { VALIDATE as NODE_REINFORCEMENT_VALIDATION } from "../feature/services/rinforzo-nodo";
const isNextStepButtonVisible = (activeStep, { responses }) => {
  const requiredQuestions = activeStep.questions.filter((q) => q.required);
  return requiredQuestions.every((q) => {
    if (!responses[q.id]) return false;

    // custom validations
    if (q.input_type === "connector_input") {
      const validation = CONNETTORI_VALIDATION[q.metadata_?.type];
      if (!validation)
        throw new Error(
          `Unhandled connector input type '${q.metadata_?.type}'`
        );
      return validation(responses[q.id].value);
    } else if (q.input_type === "node_reinforcement_input") {
      const validation = NODE_REINFORCEMENT_VALIDATION;
      return validation(responses[q.id].value);
    }

    return true;
  });
};

export default isNextStepButtonVisible;
